// extracted by mini-css-extract-plugin
export var brand = "_7t-8";
export var compact = "_7t-5";
export var extraSmall = "_7t-6";
export var icon = "_7t-0";
export var large = "_7t-3";
export var light = "_7t-1";
export var medium = "_7t-4";
export var outline = "_7t-a";
export var primaryDark = "_7t-9";
export var primaryLight = "_7t-7";
export var primaryModern = "_7t-b";
export var success = "_7t-2";